import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa6";

import styles from './Navbar.module.css';

export const Navbar = () => {

    const scrollToLogin = () => {

        document.getElementById('login-section')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

    };

    return (
        <>
            <nav className={"navbar navbar-expand-xxl fixed-top bg-body-tertiary p-3 " + styles.navbar}>
                <div className={"container " + styles.navbarContainerFluid}>
                    <Link to="/" className="navbar-brand">
                        <div className={styles.navbarLogo} />
                    </Link>
                    <button className={"navbar-toggler " + styles.navbarToggler} type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
                        <FaBars />
                    </button>
                    <div className={"collapse navbar-collapse " + styles.navbarColapse} id="navbarToggler">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            {/* <li className={"nav-item " + styles.navTextItem}><Link to="https://clinicasdelazucar.com/" className={styles.navTextItemA}>NOSOTROS</Link></li>   */}
                            {/* <li className={"nav-item " + styles.navTextItem}><Link to="https://clinicasdelazucar.com/" className={styles.navTextItemA}>¿CÓMO FUNCIONA?</Link></li> */}
                            {/* <li className={"nav-item " + styles.navTextItem}><Link to="https://clinicasdelazucar.com/" className={styles.navTextItemA}>HISTORIAS DE ÉXITO</Link></li> */}
                            {/* <li className={"nav-item " + styles.navTextItem}><Link to="https://clinicasdelazucar.com/" className={styles.navTextItemA}>PLANES</Link></li> */}
                            {/* <li className={"nav-item " + styles.navTextItem}><Link to="https://clinicasdelazucar.com/" className={styles.navTextItemB}>CONSULTA VIRTUAL</Link></li> */}
                            <li className={"nav-item " + styles.navTextItem + " " + styles.navTextItemB} onClick={scrollToLogin}>CONSULTA VIRTUAL</li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}
